import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute, LayoutSplashScreen } from "../../../_metronic/layout";
import { BranchCourseCustomizationList } from "./BranchCourseCustomizationList";
import { BranchCourseCustomizationEdit } from "./Components/BranchCourseCustomizationEdit";

export default function BranchCourseCustomizationPage({ history }) {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Redirect
          exact={true}
          from="/branch-course-customization"
          to="/branch-course-customization/list"
        />
        <ContentRoute
          path="/branch-course-customization/create"
          component={BranchCourseCustomizationEdit}
        />
        <ContentRoute
          path="/branch-course-customization/edit/:id"
          component={BranchCourseCustomizationEdit}
        />
        <ContentRoute
          path="/branch-course-customization/list"
          component={BranchCourseCustomizationList}
        />
      </Switch>
    </Suspense>
  );
}
